import { useMemo } from "react"
import { useScrollContext } from "../components/Scroll"
import { useIsDesktop } from "../providers/DeviceProvider"

export default function useVisible3D(visible = undefined) {
	const isDesktop = useIsDesktop(true)
	const { isCanvasAvailable } = useScrollContext("rig")
	return useMemo(() => {
		const base = isDesktop && isCanvasAvailable
		if (typeof visible === "undefined") return base
		return base && visible
	}, [visible, isCanvasAvailable, isDesktop])
}
